/**
 * Created by bootdo.
 * 平台管理api
 */
import * as API from '..'
import $const from '../../common/constant'
export default {

  findList: params => {
    return API.GET($const.apiServer.Admin+'/platform/getPageList', params);
  },
  add:params=>{
    return API.POST($const.apiServer.Admin+'/platform/save', params);
  },
  del: params => {
    return API.GET($const.apiServer.Admin+'/platform/del', params);
  },
  update:params=>{
    return API.POST($const.apiServer.Admin+'/platform/update', params);
  },
  getPlatformList: params => {
    return API.GET($const.apiServer.Admin+'/platform/getPlatformList', params);
  },
}



// WEBPACK FOOTER //
// ./src/api/platformManagement/api_platformManagement.js